// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 780) return "static/js/780.ac39d7a8db6e3676b3b6.js";
	// return url for filenames based on template
	return "static/js/" + "main" + "." + "c1f44d66a19f64090a96" + ".js";
};